import {RLTD_ACC_NOT_AVL, RLTD_ACC_AVL, DATA_AVAILABLE} from "../action";

const initialState = {
    authorized: true,
    grp3LeadIdAvailable: false
};

function relatedAccountReducer(state = initialState, action) {
    switch (action.type) {
        case RLTD_ACC_NOT_AVL:
            return {
                ...state,
                authorized: false
            };
        case RLTD_ACC_AVL:
            return {
                ...state,
                authorized: true
            };
        case DATA_AVAILABLE:
            return {
                ...state,
                grp3LeadIdAvailable :true
            }
        default:
            return state;
    }
}

export default relatedAccountReducer;
